export const ROOT_PATH = '/';
export const LOGIN_PATH = '/login';
export const LOGOUT_PATH = '/logout';
export const UNAUTHORIZED_PATH = '/unauthorized';
export const DASHBOARD_PATH = '/dashboard';
export const ACCOUNTS_PATH = '/accounts';
export const TRANSACTIONS_PATH = '/transactions';
export const CATEGORIES_PATH = '/categories';
export const ASSISTANT_PATH = '/assistant';
